<template>
  <div>
    <!-- START DATA DIRI -->
    <b-card no-body class="mb-1" v-if="currentUser.info.role_id === 4">
      <b-card-header header-tag="header" class="p-3" role="tab">
        <span class="m-1">Data PIC Badan Hukum</span>
        <b-button v-b-toggle.accordion-45 variant="yellow" class="chevron">
          <span class="when-open">
            <b-icon icon="chevron-up" />
          </span>
          <span class="when-closed">
            <b-icon icon="chevron-down" />
          </span>
        </b-button>
      </b-card-header>

      <b-collapse id="accordion-45" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-alert v-if="sectionRejectionMessages.length > 0" show variant="warning" class="mb-4">
            <b-icon icon="exclamation-triangle-fill" class="mr-2"></b-icon>
            <strong>Informasi Penolakan (Data PIC):</strong>
            <div v-for="(msg, idx) in sectionRejectionMessages" :key="idx" class="mt-2 ml-4">
              <p class="mb-1"><strong>Alasan:</strong> {{ msg.note }}</p>
              <div v-if="msg.fields && msg.fields.length > 0">
                <p class="mb-0"><strong>Data atau informasi yang memerlukan perbaikan:</strong></p>
                <ol class="mb-2">
                  <li v-for="f in msg.fields" :key="f.field" class="font-weight-bold">{{ f.label }}</li>
                </ol>
              </div>
            </div>
            <hr v-if="sectionRejectionMessages.length > 0">
            <p class="mt-2 mb-0">Untuk dapat melakukan pengajuan kembali mohon dapat memperbarui data PIC anda pada kolom yang berwarna merah di bawah ini.</p>
          </b-alert>

          <b-card-text>
            <div class="container">
              <div v-if="isLoading" class="text-center my-4">
                <b-spinner
                  label="Loading..."
                  variant="primary"
                  small
                ></b-spinner>
                <p>Memuat data, mohon tunggu...</p>
              </div>
              <b-form v-else @submit.prevent="confirmChangeData">
                <!-- <b-form @submit.prevent="updateDataBadanHukum"> -->
                <!-- START NAMA LENGKAP -->
                <div class="row">
                  <span style="font-size: 12px">Note : (*) Wajib diisi</span>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Jabatan"
                      :options="options.positions"
                      v-model="form.position_id"
                      :required="true"
                      :class="{'is-invalid': allRejectedFields && (allRejectedFields.includes('position_id') || allRejectedFields.includes('jabatan'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('position_id') || allRejectedFields.includes('jabatan')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="text"
                      label="Nama Lengkap (sesuai KTP)"
                      placeholder="Masukkan Nama Lengkap (sesuai KTP)"
                      v-model="currentUser.info.name"
                      disabled
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Jenis Kelamin"
                      :options="options.gender"
                      v-model="form.gender"
                      :required="true"
                      :class="{'is-invalid': allRejectedFields && (allRejectedFields.includes('gender') || allRejectedFields.includes('jenis_kelamin'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('gender') || allRejectedFields.includes('jenis_kelamin')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Kewarganegaraan"
                      :options="options.nationality"
                      v-model="form.nationality"
                      :required="true"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                        label="No. Ponsel yang terhubung ke WA"
                        v-model="currentUser.info.no_telpon"
                        disabled
                      />
                  </div>
                  <div class="col mt-3">
                    <label for="noTelepon" :class="{'text-danger font-weight-bold': allRejectedFields && (allRejectedFields.includes('alternate_phone') || allRejectedFields.includes('no_handphone'))}"
                        >No. Ponsel Alternatif *</label
                      >
                      <br />
                    <BFormInputWithMask
                        v-model="form.alternate_phone"
                        :required="true"
                        placeholder="Masukkan No. Ponsel Alternatif"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('alternate_phone') || allRejectedFields.includes('no_handphone'))}"
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                        type="email"
                        label="Email"
                        v-model="currentUser.info.email"
                        disabled
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="text"
                      label="Tempat Lahir"
                      placeholder="Masukkan Tempat Lahir"
                      v-model="form.place_of_birth"
                      :required="true"
                      :disabled="ekyc_verified"
                      :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('place_of_birth') || allRejectedFields.includes('tempat_lahir'))}"
                    />
                  </div>
                  <div class="col mt-3">
                    <BFormInputWithMask
                        type="date"
                        label="Tanggal Lahir"
                        v-model="form.date_of_birth"
                        :disabled="ekyc_verified"
                        :required="true"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('date_of_birth') || allRejectedFields.includes('tanggal_lahir'))}"
                        label-class="allRejectedFields && (allRejectedFields.includes('date_of_birth') || allRejectedFields.includes('tanggal_lahir')) ? 'text-danger font-weight-bold' : ''"
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Jenis Tanda Pengenal"
                      :options="options.identityType"
                      v-model="form.identity_type_id"
                      :required="true"
                    />
                  </div>
                  <div class="col mt-3">
                    <BFormInputWithMask
                        type="number"
                        label="Nomor Tanda Pengenal"
                        v-model="form.identity_number"
                        disabled
                        :class="{'is-invalid border-danger': allRejectedFields && allRejectedFields.includes('identity_number')}"
                        label-class="allRejectedFields && allRejectedFields.includes('identity_number') ? 'text-danger font-weight-bold' : ''"
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="text"
                      label="Tempat Diterbitkan"
                      placeholder="Tempat Diterbitkan Tanda Pengenal"
                      v-model="form.identity_issued_place"
                      :required="true"
                      :disabled="ekyc_verified"
                    />
                  </div>
                  <div class="col">
                    <FormInput
                      type="tanda_pengenal"
                      label="Masa Berlaku Tanda Pengenal"
                      :date-value="form.identity_expiry"
                      :lifetime-value="form.identity_lifetime"
                      @update:dateValue="form.identity_expiry = $event"
                      @update:lifetimeValue="form.identity_lifetime = $event"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col mt-3">
                    <BFormInputWithMask
                        type="number"
                        label="NPWP"
                        placeholder="NPWP"
                        v-model="form.taxpayer_number"
                        :required="true"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('taxpayer_number') || allRejectedFields.includes('npwp'))}"
                        label-class="allRejectedFields && (allRejectedFields.includes('taxpayer_number') || allRejectedFields.includes('npwp')) ? 'text-danger font-weight-bold' : ''"
                      />
                  </div>
                  <div class="col">
                    <FormInput
                      type="file"
                      label="Dokumen NPWP (pdf)"
                      :value="photo.taxpayer_document"
                      @input="
                        (val) => {
                          form.taxpayer_document = val;
                          photo.taxpayer_document = val;
                        }
                      "
                      :required="true"
                      :previewFile="form.taxpayer_document_path"
                      :class="{'is-invalid': allRejectedFields && (allRejectedFields.includes('taxpayer_document_path') || allRejectedFields.includes('npwp_attachment'))}"
                      :label-class="allRejectedFields && (allRejectedFields.includes('taxpayer_document_path') || allRejectedFields.includes('npwp_attachment')) ? 'text-danger font-weight-bold' : ''"
                    />
                  </div>
                </div>
                <!-- START ALAMAT KTP -->
                <div class="row">
                  <div class="col">
                    <BFormInputWithMask
                        label="Alamat Sesuai KTP"
                        v-model="form.identity_address"
                        placeholder="Masukan alamat sesuai KTP"
                        :required="true"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('identity_address') || allRejectedFields.includes('alamat'))}"
                        label-class="allRejectedFields && (allRejectedFields.includes('identity_address') || allRejectedFields.includes('alamat')) ? 'text-danger font-weight-bold' : ''"
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi">Provinsi *</label>
                      <br />
                      <b-form-select
                        v-model="form.identity_province_id"
                        :options="options.provinsi"
                        @input="provinsiChange(true)"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota">Kota / Kabupaten *</label>
                      <br />
                      <b-form-select
                        v-model="form.identity_city_id"
                        :options="options.kota"
                        @input="kotaChange(true)"
                        required
                        :disabled="loadingChangeProvinceKTP"
                      ></b-form-select>
                      <small
                        v-if="loadingChangeProvinceKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan">Kecamatan *</label>
                      <br />
                      <b-form-select
                        v-model="form.identity_district_id"
                        :options="options.kecamatan"
                        @input="kecamatanChange(true)"
                        required
                        :disabled="loadingChangeCityKTP"
                      ></b-form-select>
                      <small
                        v-if="loadingChangeCityKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa">Desa / Kelurahan *</label>
                      <br />
                      <b-form-select
                        v-model="form.identity_sub_district_id"
                        :options="options.kelurahan"
                        required
                        :disabled="loadingChangeDistrictKTP"
                      ></b-form-select>
                      <small
                        v-if="loadingChangeDistrictKTP"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>
                <br />
                <input
                  type="checkbox"
                  v-model="isSameAddress"
                  @change="sameAddressChange"
                />
                <label for=""
                  >Alamat domisili sesuai dengan KTP</label
                >
                <!-- START ALAMAT TERKINI -->
                <div class="row">
                  <div class="col">
                    <BFormInputWithMask
                        label="Alamat Domisili"
                        v-model="form.current_address"
                        placeholder="Masukan alamat domisili"
                        :required="true"
                        :class="{'is-invalid border-danger': allRejectedFields && (allRejectedFields.includes('current_address') || allRejectedFields.includes('alamat_terkini') || allRejectedFields.includes('alamat'))}"
                        label-class="allRejectedFields && (allRejectedFields.includes('current_address') || allRejectedFields.includes('alamat_terkini') || allRejectedFields.includes('alamat')) ? 'text-danger font-weight-bold' : ''"
                      />
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="provinsi">Provinsi *</label>
                      <br />
                      <b-form-select
                        v-model="form.current_province_id"
                        :options="options.provinsi"
                        @input="provinsiChange(false)"
                        :disabled="isSameAddress"
                        required
                      ></b-form-select>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kota">Kota / Kabupaten *</label>
                      <br />
                      <b-form-select
                        v-model="form.current_city_id"
                        :options="options.current_kota"
                        @input="kotaChange(false)"
                        :disabled="isSameAddress || loadingChangeProvince"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingChangeProvince"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kecamatan...
                      </small>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="kecamatan">Kecamatan *</label>
                      <br />
                      <b-form-select
                        v-model="form.current_district_id"
                        :options="options.current_kecamatan"
                        @input="kecamatanChange(false)"
                        :disabled="isSameAddress || loadingChangeCity"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingChangeCity"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="desa">Desa / Kelurahan *</label>
                      <br />
                      <b-form-select
                        v-model="form.current_sub_district_id"
                        :options="options.current_kelurahan"
                        :disabled="isSameAddress || loadingChangeDistrict"
                        required
                      ></b-form-select>
                      <small
                        v-if="loadingChangeDistrict"
                        class="text-muted d-block mt-1"
                        style="font-size: 11px"
                      >
                        <b-spinner
                          small
                          type="grow"
                          class="mr-1"
                          style="width: 0.8rem; height: 0.8rem"
                        ></b-spinner>
                        memuat data kelurahan...
                      </small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <FormInput
                      type="select"
                      label="Status Tempat Tinggal"
                      :options="options.residenceStatus"
                      v-model="form.residence_status_id"
                      :required="true"
                    />
                  </div>
                  <div class="col">
                    <div class="alamat mt-3">
                      <label for="negara">Negara *</label>
                      <br />
                      <b-form-input
                        type="text"
                        v-model="form.country"
                        placeholder="Masukan negara"
                        required
                        :class="{'is-invalid': allRejectedFields && allRejectedFields.includes('country')}"
                      ></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col">
                    <span>Foto KTP</span>
                    <b-img
                      v-if="Boolean(!form.foto_ktp_path)"
                      class="kyc-image"
                      src="https://cdn.efunding.id/images/upload-icon.png"
                      fluid
                      alt="ktp-photo"
                    ></b-img>
                    <b-img
                      v-if="Boolean(form.foto_ktp_path)"
                      class="kyc-image"
                      :src="form.foto_ktp_path"
                      fluid
                      alt="ktp-photo"
                    ></b-img>
                  </div>
                  <div class="col">
                    <span>Foto Selfie</span>
                    <b-img
                      v-if="Boolean(!form.foto_selfie_path)"
                      class="kyc-image"
                      :src="require('@/assets/images/icon/selfie-icon.png')"
                      fluid
                      alt="selfie-photo"
                    ></b-img>
                    <b-img
                      v-if="Boolean(form.foto_selfie_path)"
                      class="kyc-image"
                      :src="form.foto_selfie_path"
                      fluid
                      alt="selfie-photo"
                    ></b-img>
                  </div>
                </div>
                <!-- END ALAMAT KTP -->

                <!-- START TOMBOL SIMPAN -->
                <div class="row">
                  <div class="col">
                    <div class="alamat mt-4">
                      <button
                        type="submit"
                        class="btn btn-f-blue text-white mr-md-2 mr-auto px-4 rounded-0"
                      >
                        <template v-if="isLoading">
                          <b-spinner
                            small
                            type="border"
                            variant="light"
                            class="mr-2"
                            label="Memproses..."
                          ></b-spinner>
                          Memproses...
                        </template>
                        <template v-else>
                          {{ isUpdate === true ? "Ubah Data" : "Kirim Data" }}
                        </template>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- END TOMBOL SIMPAN -->
              </b-form>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <NewCustomModal
      :visible="confirmUpdateModal"
      size="medium"
      @close="closeModalProperly"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >{{
            isUpdate === false
              ? "Konfirmasi Pengisian Data"
              : "Konfirmasi Perubahan"
          }}</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Apakah Anda Yakin untuk melakukan
            {{ isUpdate === true ? "Perubahan" : "Pengiriman" }} data ini
          </div>
        </div>

        <div class="modal-action-buttons no-rekening">
          <button
            class="custom-btn danger"
            @click="closeModalProperly"
            :disabled="isLoading"
          >
            Batal
          </button>
          <button
            class="custom-btn primary d-flex align-items-center justify-content-center"
            @click="updateDataBadanHukum"
            :disabled="isLoading"
          >
            <template v-if="isLoading">
              <b-spinner
                small
                type="border"
                variant="light"
                class="mr-2"
                label="Memproses..."
              ></b-spinner>
              Memproses...
            </template>
            <template v-else> Yakin </template>
          </button>
        </div>
      </div>
    </NewCustomModal>
    <NewCustomModal
      :visible="statusChangeModal"
      size="medium"
      @close="closeModalProperly"
    >
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="require(`@/assets/images/landing_page/logo-efunding.svg`)"
          alt="logo"
          width="350"
        />

        <span
          class="title-modal"
          style="font-weight: 700; margin-top: 20px; font-size: 30px"
          >{{
            isUpdate === false
              ? "Konfirmasi Pengisian Data"
              : "Konfirmasi Perubahan"
          }}</span
        >

        <div
          style="
            background-color: #f2f2f2;
            padding: 20px;
            border-radius: 10px;
            margin-top: 30px;
            width: 100%;
            max-width: 500px;
          "
        >
          <div class="text-value" style="color: #274c8e">
            Apakah Anda Yakin untuk melakukan
            {{ isUpdate === true ? "Perubahan" : "Pengiriman" }} data ini
          </div>
        </div>

        <div class="modal-action-buttons no-rekening">
          <button
            class="custom-btn danger"
            @click="closeModalProperly"
            :disabled="isLoading"
          >
            Batal
          </button>
          <button
            class="custom-btn primary d-flex align-items-center justify-content-center"
            @click="updateDataBadanHukum"
            :disabled="isLoading"
          >
            <template v-if="isLoading">
              <b-spinner
                small
                type="border"
                variant="light"
                class="mr-2"
                label="Memproses..."
              ></b-spinner>
              Memproses...
            </template>
            <template v-else> Yakin </template>
          </button>
        </div>
      </div>
    </NewCustomModal>
    <newCustomModal :visible="statusChangeModal" size="medium">
      <div
        class="flex-column"
        style="align-items: center; justify-content: center; text-align: center"
      >
        <img
          :src="
            statusResponse === 'success'
              ? require('@/assets/images/success-icon.png')
              : require('@/assets/images/wrong-icon.png')
          "
          alt="logo"
          width="200"
        />
        <span
          :style="{
            fontWeight: '700',
            marginTop: '20px',
            fontSize: '30px',
            marginBottom: '40px',
            color: statusResponse === 'success' ? 'green' : 'red',
          }"
        >
          {{ statusResponse === "success" ? "Berhasil" : "Gagal" }}
        </span>
        <div
          :style="{
            backgroundColor:
              statusResponse === 'success' ? '#e7f8ec' : '#f2f2f2',
            padding: '20px',
            borderRadius: '10px',
            width: '100%',
            maxWidth: '500px',
          }"
        >
          <span
            :style="{ color: statusResponse === 'success' ? 'green' : 'red' }"
            >{{ messageResponse }}</span
          >
        </div>
        <div class="modal-action-buttons wrong-modal" style="margin-top:30px;">
          <button class="custom-btn" :class="statusResponse==='success'?'success':'danger'" :key="$route.fullPath" @click="closeModalstatusResponse" :disabled="isLoading">Tutup</button>
        </div>
      </div>
    </newCustomModal>
  </div>
</template>

<script>
import UserProfile from "../../api/userprofile.js";
import Corporate from "../../api/corporate/corporate.js";

import DataUsaha from "./DataUsaha";
import DataPekerjaan from "./DataPekerjaan";
import AkunBank from "./AkunBank";
import ChangePassword from "./ChangePassword";
import VerifikasiEmail from "./VerifikasiEmail";

// Vue Camera Library
import EasyCamera from "easy-vue-camera";

import FormInput from "./FormInput.vue";
import NewCustomModal from "../newCustomModal.vue";
import BFormInputWithMask from "../../components/masking-input.vue"

export default {
  name: "Profile",
  components: {
    DataPekerjaan,
    DataUsaha,
    AkunBank,
    ChangePassword,
    VerifikasiEmail,
    "v-easy-camera": EasyCamera,
    FormInput,
    NewCustomModal,
    BFormInputWithMask,
  },
  props: {
    allRejectedFields: {
      type: Array,
      default: () => []
    },
    rejectionMessages: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sectionRejectionMessages() {
      if (!this.rejectionMessages) return [];
      
      return this.rejectionMessages.map(msg => {
        const filteredFields = msg.fields ? msg.fields.filter(f => {
          const model = (f.model || '').trim().toLowerCase();
          return model === 'datapic';
        }) : [];

        if (filteredFields.length > 0) {
          return {
            note: msg.note,
            fields: filteredFields
          };
        }
        return null;
      }).filter(msg => msg !== null);
    }
  },
  data() {
    return {
      loading: false,
      photo: {
        taxpayer_document: null,
        deed_document: null,
        latest_deed_number: null,
        establishment_menkumham_document: null,
        latest_menkumham_document: null,
        business_identification_document: null,
        latest_deed_document: null,
      },
      form: {
        position_id: null,
        name: null,
        gender: null,
        nationality: null,
        alternate_phone: null,
        place_of_birth: null,
        date_of_birth: null,
        identity_type_id: null,
        identity_number: null,
        identity_expiry: null,
        identity_lifetime: null,
        identity_issued_place: null,
        taxpayer_number: null,
        taxpayer_document: null,
        identity_address: null,
        identity_province_id: null,
        identity_city_id: null,
        identity_district_id: null,
        identity_sub_district_id: null,
        current_address: null,
        current_province_id: null,
        current_city_id: null,
        current_district_id: null,
        current_sub_district_id: null,
        residence_status_id: null,
        country: null,
      },
      options: {
        provinsi: [],
        kota: [],
        kecamatan: [],
        kelurahan: [],
        current_kota: [],
        current_kecamatan: [],
        current_kelurahan: [],

        legalEntity: [],
        bussinesField: [],
        accountOpeningPurpose: [],
        fundSource: [],
        estimatedTransaction: [],
        gender: [
          {
            value: "Pria",
            text: "Pria",
          },
          {
            value: "Wanita",
            text: "Wanita",
          },
        ],
        nationality: [
          {
            value: "WNI",
            text: "WNI",
          },
          {
            value: "WNA",
            text: "WNA",
          },
        ],
        identityType: [],
        positions: [],
        identityType: [],
        residenceStatus: [],
      },
      successModal: false,
      confirmProfileModal: false,
      modalText: "",
      ekyc_verified: false,

      //modals
      confirmUpdateModal: false,
      statusChangeModal: false,

      //var
      isUpdate: null,
      isLoading: false,
      statusResponse: null,
      messageResponse: null,
      isSameAddress: false,

      loadingChangeDistrictKTP: false,
      formSnapshot: {},
    };
  },
  watch: {
    form: {
      handler(newVal) {
        if (this.isLoading || !this.formSnapshot) return;
        
        // Loop through rejected fields to see if any were modified
        this.allRejectedFields.forEach(field => {
          if (newVal[field] !== this.formSnapshot[field]) {
            this.$emit('dirty', field);
          }
        });
        
        // Update snapshot
        this.formSnapshot = JSON.parse(JSON.stringify(newVal));
      },
      deep: true
    }
  },
  mounted() {
    this.loadData();
    // this.statusChangeModal = true;
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    sameAddressChange() {
      if (this.isSameAddress) {
        this.form.current_address = this.form.identity_address;
        this.form.current_province_id = this.form.identity_province_id;
        this.form.current_city_id = this.form.identity_city_id;
        this.form.current_district_id = this.form.identity_district_id;
        this.form.current_sub_district_id = this.form.identity_sub_district_id;
      } else {
        this.form.current_address = "";
        this.form.current_province_id = "";
        this.form.current_city_id = "";
        this.form.current_district_id = "";
        this.form.current_sub_district_id = "";
      }
    },
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        // Get Profile
        const profileRes = await Corporate.getCorporateProfile();
        if (profileRes.data.meta.code === 200) {
          let dataCorporate = profileRes.data.data;

          if (dataCorporate != null) {
            this.isUpdate = true;
          }

          if (dataCorporate.date_of_birth) {
            dataCorporate.date_of_birth =
              dataCorporate.date_of_birth.split(" ")[0];
          }

          Object.assign(this.form, dataCorporate);

          // Set isSameAddress jika semua field alamat sama
          if (
            this.form.identity_address === this.form.current_address &&
            this.form.identity_province_id === this.form.current_province_id &&
            this.form.identity_city_id === this.form.current_city_id &&
            this.form.identity_district_id === this.form.current_district_id &&
            this.form.identity_sub_district_id ===
              this.form.current_sub_district_id
          ) {
            this.isSameAddress = true;
          }

          // Load data wilayah berdasarkan ID yg ada
          if (this.form.identity_province_id) await this.provinsiChange(true);
          if (this.form.identity_city_id) await this.kotaChange(true);
          if (this.form.identity_district_id) await this.kecamatanChange(true);

          if (this.form.current_province_id) await this.provinsiChange(false);
          if (this.form.current_city_id) await this.kotaChange(false);
          if (this.form.current_district_id) await this.kecamatanChange(false);
        }

        // Provinsi
        const wilayahRes = await this.$getListWilayah("provinsi");
        this.options.provinsi = (wilayahRes.data || []).map((item) => ({
          value: item.id,
          text: item.name,
        }));

        // Dropdown lainnya (paralel)
        const [
          legalEntityRes,
          businessFieldRes,
          tujuanPembukaanRes,
          sumberDanaRes,
          transaksiRes,
          positionRes,
          identityTypeRes,
          residenceRes,
        ] = await Promise.all([
          Corporate.dropdownLegalEntityIndex(),
          Corporate.dropdownBusinessField(),
          Corporate.dropdownTujuanPembukaan(),
          Corporate.dropdownSumberDana(),
          Corporate.dropdownPerkiraanTransaksi1Tahun(),
          Corporate.dropdownPosition(),
          Corporate.dropdownIdentityType(),
          Corporate.dropdownResidence(),
        ]);

        this.options.legalEntity = legalEntityRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.bussinesField = businessFieldRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.accountOpeningPurpose = tujuanPembukaanRes.data.data.map(
          (item) => ({ value: item.id, text: item.name })
        );
        this.options.fundSource = sumberDanaRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.estimatedTransaction = transaksiRes.data.data.map(
          (item) => ({ value: item.id, text: item.name })
        );
        this.options.positions = positionRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.identityType = identityTypeRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.options.residenceStatus = residenceRes.data.data.map((item) => ({
          value: item.id,
          text: item.name,
        }));

        // console.log("Final form data:", this.form);
        // Normalize this.form to handle null/undefined as empty strings for consistent comparison
        Object.keys(this.form).forEach(key => {
          if (this.form[key] === null || this.form[key] === undefined) {
            this.form[key] = "";
          }
        });
        this.formSnapshot = JSON.parse(JSON.stringify(this.form));
      } catch (error) {
        console.error("Error saat loadData:", error);
        this.$toast.error("Terjadi kesalahan saat memuat data");
      } finally {
        this.isLoading = false;
      }
    },

    async provinsiChange(isKtp) {
      if (isKtp) {
        this.loadingChangeProvinceKTP = true;
      } else {
        this.loadingChangeProvince = true;
      }
      const res = await this.$getListWilayah(
        "kota",
        isKtp ? this.form.identity_province_id : this.form.current_province_id
      );
      const resArray = res.data || [];
      const ArrData = resArray.map((item) => ({
        value: item.id,
        text: item.name,
      }));

      if (isKtp) {
        this.options.kota = ArrData;
        this.loadingChangeProvinceKTP = false;
      } else {
        this.options.current_kota = ArrData;
        this.loadingChangeProvince = false;
      }
    },

    async kotaChange(isKtp) {
      if (isKtp) {
        this.loadingChangeCityKTP = true;
      } else {
        this.loadingChangeCity = true;
      }
      const res = await this.$getListWilayah(
        "kecamatan",
        isKtp ? this.form.identity_city_id : this.form.current_city_id
      );
      const resArray = res.data || [];
      const ArrData = resArray.map((item) => ({
        value: item.id,
        text: item.name,
      }));

      if (isKtp) {
        this.options.kecamatan = ArrData;
        this.loadingChangeCityKTP = false;
      } else {
        this.options.current_kecamatan = ArrData;
        this.loadingChangeCity = false;
      }
    },

    async kecamatanChange(isKtp) {
      if (isKtp) {
        this.loadingChangeDistrictKTP = true;
      } else {
        this.loadingChangeDistrict = true;
      }
      const res = await this.$getListWilayah(
        "kelurahan",
        isKtp ? this.form.identity_district_id : this.form.current_district_id
      );
      const resArray = res.data || [];
      const ArrData = resArray.map((item) => ({
        value: item.id,
        text: item.name,
      }));

      if (isKtp) {
        this.options.kelurahan = ArrData;
        this.loadingChangeDistrictKTP = false;
      } else {
        this.options.current_kelurahan = ArrData;
        this.loadingChangeDistrict = false;
      }
    },

    validatePhoneNumber() {
      const regex = /^62[0-9]{9,14}$/;
      this.errors.no_handphone = "";

      if (!this.form.no_handphone) {
        this.errors.no_handphone = "Nomor handphone tidak boleh kosong.";
      } else if (isNaN(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone hanya boleh mengandung angka.";
      } else if (!regex.test(this.form.no_handphone)) {
        this.errors.no_handphone =
          "Nomor handphone harus diawali dengan '62' dan terdiri dari 9-14 digit angka.";
      }
    },
    validateNomorTandaPengenal() {
      this.errors.nomor_tanda_pengenal = "";

      if (this.form.jenis_tanda_pengenal == "ktp") {
        const nomorTandaPengenal = this.form.nomor_tanda_pengenal.toString();
        if (nomorTandaPengenal.length != 16) {
          this.errors.nomor_tanda_pengenal =
            "Nomor Tanda Pengenal KTP harus 16 angka.";
          return false;
        } else {
          this.errors.nomor_tanda_pengenal = "";
        }
      }
      return true;
    },
    confirmChangeData() {
      this.isLoading = true;
      this.confirmUpdateModal = true;
      this.isLoading = false;
    },
    async updateDataBadanHukum() {
      this.isLoading = true;
      // console.log("forms submit:", this.form);

      const cleanedForm = Object.fromEntries(
        Object.entries(this.form).filter(
          ([_, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      // console.log("submit payload : ", cleanedForm);

      try {
        const res = await Corporate.updateCorporateProfile(cleanedForm);
        if (res.data.meta.code === 200) {
          this.confirmUpdateModal = false;
          this.statusChangeModal = true;
          this.statusResponse = "success";
          if (this.isUpdate === true) {
            this.messageResponse = "Berhasil Mengubah Data";
          } else {
            this.messageResponse = "Berhasil Mengirim Data";
          }
          this.isLoading = false;
          this.$emit('updated');
        } else {
          this.messageResponse = res.data.meta.message;
          this.isLoading = false;
        }
        // console.log("✅ response update corporate:", res.data.meta.code);
      } catch (err) {
        console.error("❌ Gagal update corporate:", err.response.data || err);
      }

      this.isLoading = false;
    },

    confirmUpdateProfile() {
      this.loading = true;
      UserProfile.update(this.form)
        .then((res) => {
          this.loading = false;
          if (res.data.meta.code == 200) {
            this.modalText = "Data diri berhasil diubah";
            this.confirmProfileModal = false;
            this.successModal = true;
            this.loadData();
          } else {
            console.log(res.data);
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    blobToBase64(blob) {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
    },

    handleCaptureCamera() {
      this.$refs.camera.snap();
      this.photo[this.cameraType] = "";
      setTimeout(() => {
        this.blobToBase64(this.picture).then((res) => {
          if (this.cameraType === "ktp") {
            this.photo.ktp = res;
          } else if (this.cameraType === "selfie") {
            this.photo.selfie = res;
          }
        });
        this.processFile(this.picture);
      }, 1000);
    },

    processFile(blob) {
      // read the files
      var reader = new FileReader();

      if (blob instanceof Blob) {
        reader.readAsArrayBuffer(blob);
        let vm = this;

        reader.onload = function (event) {
          // blob stuff
          var blob = new Blob([event.target.result]); // create blob...
          window.URL = window.URL || window.webkitURL;

          var blobURL = window.URL.createObjectURL(blob); // and get it's URL

          // helper Image object
          var image = new Image();
          image.src = blobURL;
          image.onload = function () {
            // have to wait till it's loaded
            var canvas = document.createElement("canvas");
            var width = image.width;
            var height = image.height;

            // calculate the width and height, constraining the proportions
            if (width > height) {
              if (width > 100) {
                //height *= max_width / width;
                height = 650;
              }
            } else {
              if (height > 100) {
                //width *= max_height / height;
                width = 490;
              }
            }

            // resize the canvas and draw the image data into it
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, width, height);

            canvas.toBlob(async function (blob) {
              // console.log("width", width);
              // console.log("height", height);
              vm.blobToBase64(blob).then((res) => {
                if (vm.cameraType === "ktp") {
                  vm.form.foto_ktp = res;
                } else if (vm.cameraType === "selfie") {
                  vm.form.foto_selfie_path = res;
                }
              });
              vm.showModalCamera = false;
            });
          };
        };
      } else {
        console.log(this.picture);
      }
    },

    isPDF(file) {
      // Jika file berupa base64, periksa prefixnya
      if (file.startsWith("data:application/pdf")) return true;
      // Jika file berupa path, cek ekstensi file-nya
      const ext = file.split(".").pop().toLowerCase();
      return ext === "pdf";
    },

    handleFileUpload(event, fieldName) {
      const file = event.target.files[0];
      if (!file) return;

      // Validasi tipe file
      if (
        !(file.type.startsWith("image/") || file.type === "application/pdf")
      ) {
        alert("File harus berupa gambar atau PDF.");
        event.target.value = null;
        return;
      }

      // Konversi ke base64 (untuk preview)
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form[fieldName] = e.target.result;
        this.photo[fieldName] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    closeModalProperly() {
      this.confirmUpdateModal = false;
      this.isLoading = false;
      this.statusChangeModal = false;
    },
    closeModalstatusResponse() {
      window.location.href = '/pengajuan-saya?q=Profil';
    }
  }
};
</script>

<style scoped>
.collapsed .when-open {
  display: none;
}

.not-collapsed .when-closed {
  display: none;
}

.kyc-image {
  width: 100%;
  height: auto;
  padding: 0 !important;
  object-fit: cover;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.title-modal {
  font-size: 20px;
  color: #274c8e;
  font-weight: 500;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 90px;
}
.modal-action-buttons.no-rekening {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.custom-btn {
  background-color: #00a1ca;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}
.custom-btn.primary:disabled,
.custom-btn.primary[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.danger:disabled,
.custom-btn.danger[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/pengajuan-saya/dataPIC.vue